import { render, staticRenderFns } from "./appFormList.vue?vue&type=template&id=06b7a062"
import script from "@/controllers/custom/application_form/app-form-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/application_form/app-form-list.js?vue&type=script&lang=js&external"
import style0 from "./appFormList.vue?vue&type=style&index=0&id=06b7a062&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports